import { Metadata } from './metadata'
import { TrackVariable } from './trackVariable'

export class Song {
	public id: number
	public path: string
	public pathNormalized: string | null
	public size: number

	public metadata: Metadata
	public trackVariableMetadata?: TrackVariable[]

	constructor(data: {
		id: number
		path: string
		pathNormalized: string | null
		size: number
		metadata: Metadata
		trackVariableMetadata?: TrackVariable[]
	}) {
		this.id = data.id
		this.path = data.path
		this.pathNormalized = data.pathNormalized
		this.size = data.size
		this.metadata = data.metadata
		this.trackVariableMetadata = data.trackVariableMetadata
	}

	static create(data: Partial<Song>) {
		const defaultData = {
			id: 0,
			path: '',
			pathNormalized: null,
			size: 0,
			metadata: Metadata.create({}),
			trackVariableMetadata: [],
		}

		return new Song({
			...defaultData,
			...data,
		})
	}
}
